import patterns from '../secrets-web/src/config/patterns';

export default {
  ...patterns
}